import { useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import s from "../clinic.module.css";
import u from "../../ui/ui.module.css";
import {
  Button,
  Field,
  Input,
  Select,
  Textarea,
  FormSection,
  FormGrid,
  FormGridSpan,
} from "../../ui";

export default function AdminDoctorDataForm({
  edit,
  setEdit,
  onSubmit,
  newPassword,
  setNewPassword,
  onSetPassword,
  onDeactivate,
  isActive,
}) {
  const [specializations, setSpecializations] = useState([]);

  useEffect(() => {
    clinicAPI
      .getSpecializations()
      .then((r) =>
        setSpecializations((r.specializations || []).filter((x) => x.is_active !== false)),
      )
      .catch(() => setSpecializations([]));
  }, []);

  return (
    <form onSubmit={onSubmit} className={s.patientDataForm}>
      <FormSection title="Профиль" description="Данные для отображения и портала тренера">
        <FormGrid>
          <FormGridSpan>
            <Field label="ФИО">
              <Input
                required
                value={edit.full_name}
                onChange={(e) =>
                  setEdit({ ...edit, full_name: e.target.value })
                }
              />
            </Field>
          </FormGridSpan>
          <Field
            label="Специализация"
            hint="Из справочника «Услуги». Определяет, какие услуги предлагать в карточке тренера."
          >
            <Select
              value={edit.specialization_id}
              onChange={(e) =>
                setEdit({ ...edit, specialization_id: e.target.value })
              }
            >
              <option value="">Не указана</option>
              {specializations.map((sp) => (
                <option key={sp.id} value={sp.id}>
                  {sp.name}
                </option>
              ))}
            </Select>
            {edit.specialization && !edit.specialization_id ? (
              <span className={u.hint}>
                Сейчас в профиле: «{edit.specialization}» — выберите из списка, чтобы
                связать со справочником.
              </span>
            ) : null}
          </Field>
          <FormGridSpan>
            <Field label="Описание">
              <Textarea
                className={u.textareaCompact}
                rows={3}
                value={edit.description}
                onChange={(e) =>
                  setEdit({ ...edit, description: e.target.value })
                }
              />
            </Field>
          </FormGridSpan>
        </FormGrid>
      </FormSection>

      <FormSection title="Вход в портал тренера">
        <FormGrid>
          <Field label="Email для входа">
            <Input
              type="email"
              value={edit.email}
              onChange={(e) => setEdit({ ...edit, email: e.target.value })}
            />
          </Field>
          <Field label="Новый пароль" hint="Минимум 8 символов">
            <div className={s.inlineFieldRow}>
              <Input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <Button type="button" variant="secondary" onClick={onSetPassword}>
                Задать пароль
              </Button>
            </div>
          </Field>
        </FormGrid>
      </FormSection>

      <div className={u.formActions}>
        <Button type="submit">Сохранить</Button>
        {isActive ? (
          <Button type="button" variant="danger" onClick={onDeactivate}>
            Деактивировать тренера
          </Button>
        ) : null}
      </div>
    </form>
  );
}
